import React, { FC } from "react";
import cx from "classnames";

interface IBannerMessageProps {
  title: string;
  description: React.JSX.Element | string;
  bgColor?: "bg-white"; // can be extended
}

const BannerMessage: FC<React.PropsWithChildren<IBannerMessageProps>> = ({
  title,
  description,
  bgColor,
}: IBannerMessageProps) => {
  return (
    <div
      className={cx(
        "flex flex-col flex-1 w-full p-3 border border-grey-fog-1",
        bgColor ?? "bg-color-neutral-three"
      )}
    >
      <h6 className="text-[14px] font-bold">{title}</h6>
      <p className="text-[14px]">{description}</p>
    </div>
  );
};

export default BannerMessage;
